module.exports = __webpack_public_path__ + "../resources/img/ic_re_lt_ef_layer_set_1_img.47edb283.svg";